import './styles/new-maintenance-modal.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import classnames from 'classnames'

import { Modal, Button, Form, Message } from 'semantic-ui-react'

import DateTimeRangeFilter from '../components/DateTimeRangeFilter'

import api from '../redux/api'

import { getFormattedError } from '../graphql/utils'

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
const timeOffsetMessage = `Times are shown in Local Time (${timezone}, UTC/GMT ${-new Date().getTimezoneOffset() / 60})`

export default class NewMaintenanceModal extends React.Component {
  static propTypes = {
    open:                PropTypes.bool.isRequired,
    onClose:             PropTypes.func.isRequired,
    history:             PropTypes.object.isRequired,
    maintenanceTemplate: PropTypes.object.isRequired,
  }

  state = {
    before: 0,
    after:  0,
    saving: false,
    error:  null,
  }

  handleTimeChange = (data) => {
    this.setState({ before: data.before, after: data.after })
  }

  handleConsumeEvent = (event) => {
    event.stopPropagation()
  }

  handleConfirm = () => {
    const { maintenanceTemplate } = this.props
    const { before, after } = this.state

    const startTime = new Date(after).toISOString()
    const endTime   = new Date(before).toISOString()

    this.setState({ saving: true }, () => {
      api.addMaintenance({ template: maintenanceTemplate.id, startTime, endTime }).then(() => {
        setTimeout(() => {            
          this.setState({ saving: false, error: null }, () => {
            this.props.onClose()
            this.props.history.push('/maintenance')            
          })
        }, 2000) // Give time to read side sync...
      }).catch((error) => {
        this.setState({ saving: false, error: getFormattedError(error) })
      })
    })
  }

  render() {
    const { open, maintenanceTemplate } = this.props
    const { before, after, saving } = this.state

    const message = `
      You are about to start a new Maintenance Mode base on the selected Maintenance Mode Temaplte "${maintenanceTemplate.name}".
      Please select the maintenance mode start and end time.
    `

    const isValid = before > 0 && after > 0

    const canApply  = !saving && isValid
    const canCancel = !saving

    const glassPaneClass = classnames('glass-pane', { saving })

    return (
      <Modal centered={false} open={open} onClick={this.handleConsumeEvent}>
        <div className="new-maintenance-modal-content">
          <div className={glassPaneClass} />

          <Form>
            <Message>
              <Message.Header>Start New Maintenance Mode</Message.Header>
              <br />
              <p> {message} </p>
            </Message>

            <Form.Field>
              <div className="timezone-tip">{ timeOffsetMessage }</div>

              <DateTimeRangeFilter
                onChange={this.handleTimeChange}
                defaultFilterConfig={{ after, before }}
              />
            </Form.Field>
          </Form>
        </div>

        <Modal.Actions>
          <Button onClick={this.props.onClose} disabled={!canCancel}>Cancel</Button>
          <Button onClick={this.handleConfirm} primary disabled={!canApply}>OK</Button>
        </Modal.Actions>
      </Modal>
    )
  }
}